/*!
 * Inayah Size Guide BUTTON Mover (only)
 *
 * Moves the `.product__size-guide-button` element so it sits on its own
 * right-aligned line directly ABOVE the Size dropdown (Dissh-style).
 *
 * NOTE: All modal scroll-lock / teleport / overlay behavior is now handled
 * by inayah-size-guide-modal.js — this file only manages the button position.
 */
(function () {
  "use strict";

  var MOVED_CLASS = "inayah-size-guide-moved";

  function moveSizeGuide(root) {
    root = root || document;
    var guide = root.querySelector(".product__size-guide-button");
    if (!guide) return;
    if (guide.classList.contains(MOVED_CLASS)) return;
    var sizeOption = root.querySelector('[data-product-option="Size"]') ||
                     root.querySelector('[data-product-option="size"]') ||
                     root.querySelector('.product-options__option.option-type-size');
    if (!sizeOption) return;
    var dropdown = sizeOption.querySelector(".prod__option");
    if (!dropdown) return;
    sizeOption.insertBefore(guide, dropdown);
    guide.classList.add(MOVED_CLASS);
  }

  function run() {
    try { moveSizeGuide(document); } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  var moverObserver = new MutationObserver(function () { run(); });
  moverObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
